import { useCallback, useEffect, useRef, useState } from "react";
import "../../Styles/Header.css";
import {
  FiSearch,
  FiUser,
  FiShoppingCart,
  FiHelpCircle,
  FiUsers,
  FiPhone,
  FiMail,
  FiMenu,
  FiX,
  FiMessageSquare,
  FiGlobe,
  FiMapPin,
  FiChevronDown,
  FiTag,
  FiChevronRight,
} from "react-icons/fi";
import { FaHeart } from "react-icons/fa";
import Modal from "../Modal/Modal";
import { connect } from "react-redux";
import { getCartRequest } from "../../Containers/Home/Home-slice";
import { getcategorywithsubcategoryRequest } from "../../Containers/Home/Home-slice";
import nexoraimg from "../../assests/elumiya.png";
import axiosInstance from "../../utils/AxiosConfig";
import { useNavigate } from "react-router";
import { DEFAULT_PRODUCT_IMAGE, withDefaultProductImage } from "../../utils/productPresentation";
import { openAuthModal } from "../../utils/authModal";
import {
  getStorageItem,
  getViewportIsMobile,
  setStorageItem,
} from "../../utils/browser";
import { getBuyerToken, getBuyerUser } from "../../utils/authStorage";
import { getGuestCartCount, GUEST_CART_EVENT } from "../../utils/guestCart";
import {
  CLINICAL_PLANNERS_PATH,
  getNavigationCategories,
  isClinicalPlannersCategory,
} from "../../utils/clinicalPlanners";
import { getCustomerCategoryTree } from "../../utils/catalogMenuView";

function Header({ getcartRequest, getcategorywithsubcategoryRequest, cartData, categoryTree }) {
  const [token, setToken] = useState(null);
  const [helpOpen, setHelpOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [assistantOpen, setAssistantOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [products, setProducts] = useState([]);
  const [username, setusername] = useState();
  const [guestCartCount, setGuestCartCount] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [locationOpen, setLocationOpen] = useState(false);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [expandedSubcategory, setExpandedSubcategory] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState("Dubai");

  const helpRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const mobileMenuButtonRef = useRef(null);
  const mobileMenuCloseRef = useRef(null);
  const locationRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (isMobile && !Array.isArray(categoryTree)) {
      getcategorywithsubcategoryRequest();
    }
  }, [isMobile, categoryTree, getcategorywithsubcategoryRequest]);

  useEffect(() => {
    if (!mobileMenuOpen) return undefined;
    const menuButton = mobileMenuButtonRef.current;
    mobileMenuCloseRef.current?.focus();
    const onKeyDown = (event) => {
      if (event.key === "Escape") setMobileMenuOpen(false);
      if (event.key !== "Tab" || !mobileMenuRef.current) return;
      const focusable = [...mobileMenuRef.current.querySelectorAll('a[href], button:not([disabled])')];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      menuButton?.focus();
    };
  }, [mobileMenuOpen]);

  const goToCategory = (category, subcategory) => {
    if (!subcategory && isClinicalPlannersCategory(category)) {
      navigate(CLINICAL_PLANNERS_PATH);
      setMobileMenuOpen(false);
      return;
    }

    const params = new URLSearchParams({
      type: subcategory ? "subcategory" : "category",
      categoryId: String(category.id),
      categoryName: category.name,
    });
    if (subcategory) {
      params.set("subcategoryId", String(subcategory.id));
      params.set("subcategoryName", subcategory.name);
    }
    navigate(`/categoryproducts?${params.toString()}`);
    setMobileMenuOpen(false);
  };

  const goToTag = (category, tag) => {
    if (tag.legacy_sub_category_id) {
      goToCategory(category, { id: tag.legacy_sub_category_id, name: tag.name });
      return;
    }

    navigate(`/search?q=${encodeURIComponent(tag.name)}`);
    setMobileMenuOpen(false);
  };

  const locations = [
    { name: "Dubai", emoji: "🇦🇪", city: "Dubai" },
    { name: "Sharjah", emoji: "🇦🇪", city: "Sharjah" },
    { name: "Abu Dhabi", emoji: "🇦🇪", city: "Abu Dhabi" },
    { name: "Ajman", emoji: "🇦🇪", city: "Ajman" },
    { name: "Ras Al Khaimah", emoji: "🇦🇪", city: "Ras Al Khaimah" },
    { name: "Fujairah", emoji: "🇦🇪", city: "Fujairah" },
    { name: "Umm Al Quwain", emoji: "🇦🇪", city: "Umm Al Quwain" },
  ];

  // Check screen size for mobile
  useEffect(() => {
    setIsMobile(getViewportIsMobile());

    const handleResize = () => {
      setIsMobile(getViewportIsMobile());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const syncSession = useCallback(() => {
    const storedToken = getBuyerToken();
    const user = getBuyerUser();
    setToken(storedToken);
    setusername(user?.username);
    setGuestCartCount(storedToken ? 0 : getGuestCartCount());
    getcartRequest();
  }, [getcartRequest]);

  const handleSearch = async (event) => {
    const value = event.target.value;
    setSearch(value);

    if (!value.trim()) {
      setProducts([]);
      return;
    }

    try {
      const response = await axiosInstance.get(`searchProducts?q=${value}`);

      if (response.data.success) {
        setProducts(response.data.results || []);
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  const handleProductSelect = (product) => {
    navigate(`/product/${product.id}`, { state: { product } });
    setProducts([]);
    setSearch("");
    setMobileMenuOpen(false);
  };

  const submitSearch = (event) => {
    event.preventDefault();
    const query = search.trim();
    if (query) {
      navigate(`/search?q=${encodeURIComponent(query)}`);
      setProducts([]);
      setMobileMenuOpen(false);
    }
  };

  const handleLocationChange = (location) => {
    setSelectedLocation(location.name);
    setLocationOpen(false);
    setStorageItem("selectedLocation", location.name);
    // You can also dispatch an action to update location in Redux
    // dispatch(updateLocation(location.name));
  };

  useEffect(() => {
    const savedLocation = getStorageItem("selectedLocation", "");
    if (savedLocation) {
      setSelectedLocation(savedLocation);
    }
  }, []);

  useEffect(() => {
    syncSession();
  }, [syncSession]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (helpRef.current && !helpRef.current.contains(event.target)) {
        setHelpOpen(false);
      }

      if (locationRef.current && !locationRef.current.contains(event.target)) {
        setLocationOpen(false);
      }

      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        !event.target.closest(".mobile-menu-btn")
      ) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (!getViewportIsMobile()) {
        setMobileMenuOpen(false);
      }
    };

    const handleStorage = () => syncSession();

    window.addEventListener("resize", handleResize);
    window.addEventListener("storage", handleStorage);
    window.addEventListener(GUEST_CART_EVENT, handleStorage);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener(GUEST_CART_EVENT, handleStorage);
    };
  }, [syncSession]);

  useEffect(() => {
    if (!mobileMenuOpen) {
      document.body.classList.remove("header-mobile-menu-open");
      return undefined;
    }

    document.body.classList.add("header-mobile-menu-open");
    return () => document.body.classList.remove("header-mobile-menu-open");
  }, [mobileMenuOpen]);

  const cartCount = token
    ? Array.isArray(cartData)
      ? cartData.reduce((sum, item) => sum + (Number(item.quantity) || 1), 0)
      : 0
    : guestCartCount;

  return (
    <>
      <header className="site-header" role="banner">
        <div className="mobile-delivery-strip">Delivery across UAE · Free delivery over AED 1,000</div>
        <div className="header-inner">
          <div className="header-left">
            <button
              className="mobile-menu-btn"
              ref={mobileMenuButtonRef}
              onClick={() => setMobileMenuOpen((prev) => !prev)}
              aria-label="Toggle menu"
              aria-expanded={mobileMenuOpen}
              type="button"
            >
              {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>

            <a href="/" className="user-header-logo" aria-label="Home - Elumia">
              <img src={nexoraimg} alt="Elumia" style={{ width: "104px" }} />
            </a>

            {/* Location Selector with Dropdown */}
            <div style={{ display:'flex', alignItems:'center', flexDirection:'column' }} className="location-section">
              <div style={{ color:'white', fontSize:'12px' }}>Delivery To</div>
              <div className="location-selector" ref={locationRef}>
                <button
                  className="location-button"
                  onClick={() => setLocationOpen((prev) => !prev)}
                  aria-label="Select location"
                  aria-expanded={locationOpen}
                  type="button"
                >
                  <FiMapPin className="location-icon" />
                  <span className="location-text">{selectedLocation}</span>
                  <FiChevronDown
                    className={`location-chevron ${locationOpen ? "rotated" : ""}`}
                    size={14}
                  />
                </button>

                {locationOpen && (
                  <div className="location-dropdown">
                    {locations.map((location) => (
                      <button
                        key={location.name}
                        className={`location-option ${selectedLocation === location.name ? "active" : ""}`}
                        onClick={() => handleLocationChange(location)}
                        type="button"
                      >
                        <span className="location-option-emoji">
                          {location.emoji}
                        </span>
                        <span className="location-option-name">
                          {location.name}
                        </span>
                        {selectedLocation === location.name && (
                          <span className="location-option-check">✓</span>
                        )}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Desktop Search Bar - Hidden on Mobile */}
          {!isMobile && (
            <div className="header-center">
              <form
                className="search-form"
                onSubmit={(event) => event.preventDefault()}
                role="search"
                aria-label="Search products"
              >
                <label htmlFor="search-input" className="visually-hidden">
                  Search
                </label>
                <input
                  id="search-input"
                  className="search-input"
                  type="search"
                  placeholder="Search products, brands, and categories"
                  value={search}
                  onChange={handleSearch}
                  aria-label="Search for products"
                />
                <button
                  className="search-btn"
                  aria-label="Search"
                  type="submit"
                >
                  <FiSearch size={18} />
                </button>
              </form>

              {products.length > 0 && (
                <div className="search-dropdown">
                  {products.map((product) => (
                    <button
                      key={product.id}
                      type="button"
                      className="search-item"
                      onClick={() => handleProductSelect(product)}
                    >
                      <img
                        src={withDefaultProductImage(product.image)}
                        width="44"
                        alt={product.name}
                        onError={(event) => {
                          event.currentTarget.src = DEFAULT_PRODUCT_IMAGE;
                        }}
                      />
                      <div>
                        <div className="search-name">{product.name}</div>
                        <div className="search-price">AED {product.price}</div>
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}

          <div
            className="header-right desktop-only"
            role="navigation"
            aria-label="Header navigation"
          >
            {!token && (
              <a className="action-item-be-a-seller" href="/sellerhome">
                <FiUsers className="action-icon" />
                <span className="action-label">Be a Seller</span>
              </a>
            )}

            <div
              className="header-language"
              role="group"
              aria-label="Language selector"
            >
              <span className="header-language__icon" aria-hidden="true">
                <FiGlobe />
              </span>

              <button
                type="button"
                className="header-language__btn is-active"
                aria-pressed="true"
              >
                <img
                  src="https://flagcdn.com/w40/us.png"
                  alt="English (US)"
                  className="flag-icon"
                />
              </button>

              <button
                type="button"
                className="header-language__btn is-placeholder"
                aria-disabled="true"
                title="Arabic support coming soon"
              >
                <img
                  src="https://flagcdn.com/w40/ae.png"
                  alt="Arabic"
                  className="flag-icon"
                />
              </button>
            </div>

            <a className="action-item action-item-ghost" href="/offers">
              <FiTag className="action-icon" />
              <span className="action-label">Offers</span>
            </a>

            <div className="help-dropdown" ref={helpRef}>
              <button
                type="button"
                className="action-item action-item-ghost"
                onClick={() => setHelpOpen((prev) => !prev)}
                aria-haspopup="true"
                aria-expanded={helpOpen}
              >
                <FiHelpCircle className="action-icon" />
                <span className="action-label">Contact us</span>
              </button>
              {helpOpen && (
                <div className="help-menu">
                  <div className="help-item">
                    <FiPhone />
                    <span>+971 50 257 6257</span>
                  </div>
                  <div className="help-item">
                    <FiMail />
                    <span>info@elumiamedstore.com</span>
                  </div>
                </div>
              )}
            </div>

            <a
              className="action-item action-item-cart"
              href="/cart"
              aria-label={`Cart (${cartCount})`}
            >
              <div className="cart-icon-wrapper">
                <FiShoppingCart className="action-icon cart-icon" />
                {cartCount > 0 && (
                  <span className="cart-icon-badge" aria-hidden="true">
                    {cartCount}
                  </span>
                )}
              </div>
              <span className="action-label">Cart</span>
            </a>

            {!token ? (
              <button
                className="login-btn"
                type="button"
                aria-haspopup="dialog"
                onClick={openAuthModal}
              >
                <FiUser className="login-icon" />
                <span>Login</span>
              </button>
            ) : (
              <>
                <div
                  className="account-btn"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    navigate("/account", {
                      state: { navigationname: "wishlist" },
                    })
                  }
                >
                  <FaHeart color="red" className="login-icon" />
                </div>
                {username !== undefined && (
                  <button
                  className="account-btn"
                  type="button"
                  aria-label="My account"
                  onClick={() =>
                    navigate("/account", {
                      state: { navigationname: "profile" },
                    })
                  }
                >
                  <FiUser className="login-icon" />
                  <span style={{ color: "white" }} className="profile-name">
                    Hi, {username}
                  </span>
                </button>
                )}
                
              </>
            )}
            {/* {username !== undefined && (
              <div>
                <span style={{ color: "white" }} className="profile-name">
                  Hi, {username}
                </span>
              </div>
            )} */}
          </div>

          {/* Mobile Tools - Only visible on mobile */}
          {isMobile && (
            <div className="header-mobile-tools">
              <button
                type="button"
                className="header-mobile-tool"
                aria-label="Open AI Assistant"
                onClick={() => setAssistantOpen(true)}
              >
                <FiMessageSquare size={20} />
              </button>

              <div
                className="header-language header-language--compact"
                role="group"
                aria-label="Language selector"
              >
                <button
                  type="button"
                  className="header-language__btn is-active"
                  aria-pressed="true"
                >
                  <img
                    src="https://flagcdn.com/w40/us.png"
                    alt="English"
                    className="flag-icon"
                    style={{ width: "18px", height: "12px" }}
                  />
                </button>
                <button
                  type="button"
                  className="header-language__btn is-placeholder"
                  aria-disabled="true"
                  title="Arabic support coming soon"
                >
                  <img
                    src="https://flagcdn.com/w40/ae.png"
                    alt="Arabic"
                    className="flag-icon"
                    style={{ width: "18px", height: "12px" }}
                  />
                </button>
              </div>

              <a
                className="mobile-cart-icon"
                href="/cart"
                aria-label={`Cart (${cartCount})`}
              >
                <div className="cart-icon-wrapper">
                  <FiShoppingCart size={22} />
                  {cartCount > 0 && (
                    <span className="cart-icon-badge" aria-hidden="true">
                      {cartCount}
                    </span>
                  )}
                </div>
              </a>
            </div>
          )}
        </div>

        {isMobile && (
          <div className="header-mobile-search-row">
            <div className="header-mobile-search-shell">
              <form
                className="mobile-search-form header-mobile-search-form"
                onSubmit={submitSearch}
                role="search"
                aria-label="Search products"
              >
                <input
                  className="mobile-search-input"
                  type="search"
                  placeholder="What are you looking for?"
                  aria-label="Search for products"
                  value={search}
                  onChange={handleSearch}
                />
                <button
                  className="mobile-search-btn"
                  aria-label="Search"
                  type="submit"
                >
                  <FiSearch size={18} />
                </button>
              </form>

              {products.length > 0 && (
                <div className="mobile-search-results header-mobile-search-results">
                  {products.map((product) => (
                    <button
                      key={product.id}
                      type="button"
                      className="search-item"
                      onClick={() => handleProductSelect(product)}
                    >
                      <img
                        src={withDefaultProductImage(product.image)}
                        width="40"
                        alt={product.name}
                        onError={(event) => {
                          event.currentTarget.src = DEFAULT_PRODUCT_IMAGE;
                        }}
                      />
                      <div>
                        <div className="search-name">{product.name}</div>
                        <div className="search-price">AED {product.price}</div>
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {mobileMenuOpen && (
          <div className="mobile-menu" onMouseDown={(event) => {
            if (event.target === event.currentTarget) setMobileMenuOpen(false);
          }}>
            <div className="mobile-menu-content" ref={mobileMenuRef} role="dialog" aria-modal="true" aria-label="Shop menu">
              <div className="mobile-menu-heading">
                <strong>Menu</strong>
                <button ref={mobileMenuCloseRef} type="button" onClick={() => setMobileMenuOpen(false)} aria-label="Close menu"><FiX size={22} /></button>
              </div>
              <div className="mobile-nav-items">
                <a className="mobile-nav-item" href="/">Home</a>
                <div className="mobile-category-list" aria-label="Shop categories">
                  <strong className="mobile-category-label">Shop by category</strong>
                  {Array.isArray(categoryTree) && categoryTree.map((category) => (
                    <div className="mobile-category-group" key={category.id}>
                      <div className="mobile-category-row">
                        <button type="button" className="mobile-category-link" onClick={() => goToCategory(category)}>{category.name}</button>
                        {category.sub_categories?.length > 0 && (
                          <button type="button" className="mobile-category-expand" aria-label={`${expandedCategory === category.id ? "Collapse" : "Expand"} ${category.name}`} aria-expanded={expandedCategory === category.id} onClick={() => { setExpandedSubcategory(null); setExpandedCategory(expandedCategory === category.id ? null : category.id); }}><FiChevronDown size={18} /></button>
                        )}
                      </div>
                      {expandedCategory === category.id && category.sub_categories?.length > 0 && (
                        <div className="mobile-subcategories">
                          {category.sub_categories.map((subcategory) => (
                            <div key={subcategory.id}>
                              <div className="mobile-subcategory-row">
                                <button type="button" onClick={() => goToCategory(category, subcategory)}>{subcategory.name}{!subcategory.tags?.length && <FiChevronRight size={16} />}</button>
                                {subcategory.tags?.length > 0 && (
                                  <button type="button" className="mobile-subcategory-expand" aria-label={`${expandedSubcategory === subcategory.id ? "Collapse" : "Expand"} ${subcategory.name} tags`} aria-expanded={expandedSubcategory === subcategory.id} onClick={() => setExpandedSubcategory(expandedSubcategory === subcategory.id ? null : subcategory.id)}><FiChevronDown size={16} /></button>
                                )}
                              </div>
                              {expandedSubcategory === subcategory.id && subcategory.tags?.length > 0 && (
                                <div className="mobile-subcategory-tags">
                                  {subcategory.tags.map((tag) => (
                                    <button type="button" key={tag.id} onClick={() => goToTag(category, tag)}>{tag.name}</button>
                                  ))}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                {/* Location in mobile menu with dropdown */}
                <div className="mobile-location-section">
                  <button
                    className="mobile-nav-item"
                    onClick={() => setLocationOpen((prev) => !prev)}
                  >
                    <FiMapPin className="mobile-nav-icon" />
                    <span>Delivery Location</span>
                    <span className="mobile-location-value">
                      {selectedLocation}
                    </span>
                    <span className="mobile-chevron">
                      {locationOpen ? "▼" : "▶"}
                    </span>
                  </button>

                  {locationOpen && (
                    <div className="mobile-location-dropdown">
                      {locations.map((location) => (
                        <button
                          key={location.name}
                          className={`mobile-location-option ${selectedLocation === location.name ? "active" : ""}`}
                          onClick={() => handleLocationChange(location)}
                          type="button"
                        >
                          <span className="location-option-emoji">
                            {location.emoji}
                          </span>
                          <span className="location-option-name">
                            {location.name}
                          </span>
                          {selectedLocation === location.name && (
                            <span className="location-option-check">✓</span>
                          )}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                <a
                  className="mobile-nav-item"
                  href="/offers"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <FiTag className="mobile-nav-icon" />
                  <span>Offers</span>
                </a>

                {!token && (
                  <a
                    className="mobile-nav-item"
                    href="/sellerhome"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    <FiUsers className="mobile-nav-icon" />
                    <span>Be a Seller</span>
                  </a>
                )}

                <button
                  type="button"
                  className="mobile-nav-item"
                  onClick={() => {
                    setAssistantOpen(true);
                    setMobileMenuOpen(false);
                  }}
                >
                  <FiMessageSquare className="mobile-nav-icon" />
                  <span>AI Assistant</span>
                </button>

                <div className="mobile-language-card">
                  <div className="mobile-language-card__label">
                    <FiGlobe className="mobile-nav-icon" />
                    <span>Language</span>
                  </div>
                  <div className="header-language">
                    <button
                      type="button"
                      className="header-language__btn is-active"
                      aria-pressed="true"
                    >
                      <img
                        src="https://flagcdn.com/w40/us.png"
                        alt="English"
                        className="flag-icon"
                        style={{ width: "20px", height: "14px" }}
                      />
                    </button>
                    <button
                      type="button"
                      className="header-language__btn is-placeholder"
                      aria-disabled="true"
                      title="Arabic support coming soon"
                    >
                      <img
                        src="https://flagcdn.com/w40/ae.png"
                        alt="Arabic"
                        className="flag-icon"
                        style={{ width: "20px", height: "14px" }}
                      />
                    </button>
                  </div>
                </div>

                <div className="mobile-help-section">
                  <button
                    type="button"
                    className="mobile-nav-item"
                    onClick={() => setHelpOpen((prev) => !prev)}
                  >
                    <FiHelpCircle className="mobile-nav-icon" />
                    <span>Help</span>
                    <span className="mobile-chevron">
                      {helpOpen ? "▼" : "▶"}
                    </span>
                  </button>

                  {helpOpen && (
                    <div className="mobile-help-menu">
                      <div className="mobile-help-item">
                        <FiPhone size={16} />
                        <a href="tel:+971502576257">+971 50 257 6257</a>
                      </div>
                      <div className="mobile-help-item">
                        <FiMail size={16} />
                        <a href="mailto:info@elumiamedstore.com">info@elumiamedstore.com</a>
                      </div>
                      <a className="mobile-help-item" href="https://wa.me/971502576257" target="_blank" rel="noreferrer">WhatsApp support</a>
                    </div>
                  )}
                </div>

                {!token ? (
                  <button
                    className="mobile-nav-item mobile-login-btn"
                    type="button"
                    onClick={() => {
                      openAuthModal();
                      setMobileMenuOpen(false);
                    }}
                  >
                    <FiUser className="mobile-nav-icon" />
                    <span>Login</span>
                  </button>
                ) : (
                  <>
                    <button
                      className="mobile-nav-item mobile-account-btn"
                      type="button"
                      onClick={() => {
                        window.location.href = "/account";
                        setMobileMenuOpen(false);
                      }}
                    >
                      <FiUser className="mobile-nav-icon" />
                      <span>My Account</span>
                    </button>
                    {username !== undefined && (
                      <div
                        className="mobile-nav-item"
                        style={{
                          background: "#f5f5f5",
                          justifyContent: "center",
                        }}
                      >
                        <span>Hi, {username}</span>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </header>
      <Modal
        isOpen={assistantOpen}
        onClose={() => setAssistantOpen(false)}
        maxWidth="420px"
      >
        <div className="header-placeholder-modal modal-shell modal-shell--centered modal-shell--compact">
          <div className="modal-header modal-header--centered">
            <p className="header-placeholder-modal__eyebrow modal-kicker">
              Placeholder
            </p>
            <h2 className="modal-title">AI Assistant</h2>
            <p className="modal-subtitle">
              Conversational shopping help is planned for a later phase. This
              entry is live in the header now so the layout and future access
              point are in place without changing any backend behavior.
            </p>
          </div>
          <div className="modal-actions modal-actions--centered">
            <button
              type="button"
              className="header-placeholder-modal__action modal-button modal-button--primary"
              onClick={() => setAssistantOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    cartData: state.Home.getCartdata?.data,
    categoryTree: getNavigationCategories(
      getCustomerCategoryTree(state.Home.getcategorywithsubcategorydata?.data),
    ),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getcartRequest: () => dispatch(getCartRequest()),
    getcategorywithsubcategoryRequest: () => dispatch(getcategorywithsubcategoryRequest()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
